import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createCndnTypes,
  fetchAllCndnTypes,
  updateCndnTypes,
  fetchOneCndnTypes,
  deleteCndnTypes,
} from "services/cndntypes";

// Fetch all credit/debit note types with optional filtering
export const useAllCndnTypes = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["cndntypes", filters],
    queryFn: () => fetchAllCndnTypes(filters),
    enabled,
  });
};

// Fetch single credit/debit note type by ID
export const useOneCndnTypes = (id, enabled = true) => {
  return useQuery({
    queryKey: ["cndntypes", id],
    queryFn: () => fetchOneCndnTypes(id),
    enabled: Boolean(id) && enabled,
  });
};

// Create new credit/debit note type
export const useCreateCndnTypes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createCndnTypes(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cndntypes"] });
    },
  });
};

// Update existing credit/debit note type
export const useUpdateCndnTypes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateCndnTypes(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["cndntypes"] });
      queryClient.invalidateQueries({ queryKey: ["cndntypes", variables.id] });
    },
  });
};

// Delete credit/debit note type
export const useDeleteCndnTypes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteCndnTypes(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["cndntypes"] });
      queryClient.invalidateQueries({ queryKey: ["cndntypes", id] });
    },
  });
};
